export enum MapTypesEnum {
  DEFAULT = 'DEFAULT',
  SATELLITE = 'SATELLITE',
}
